import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import {type ActiveFilter, SortByOption} from '~/GalleryPB/types/filters';

export interface FiltersStoreState {
  activeFilters: ActiveFilter[];
  sortBy: SortByOption;
}

const initialState: FiltersStoreState = {
  activeFilters: [],
  sortBy:
    (new URLSearchParams(window.location.search).get('sort_by') as SortByOption) ??
    SortByOption.MOST_POPULAR,
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setActiveFilters: (state, action: PayloadAction<ActiveFilter[]>) => {
      state.activeFilters = action.payload;
    },
    setSortBy: (state, action: PayloadAction<SortByOption>) => {
      state.sortBy = action.payload;
    },
  },
  selectors: {
    selectActiveFilters: (state) => state.activeFilters,
    selectHasActiveFilters: (state) => state.activeFilters.length > 0,
    selectActiveFilterGroups: (state) =>
      Array.from(new Set(state.activeFilters.map((f) => f.filterSection))),
    selectActiveFilterCount: (state) => state.activeFilters.length,
    selectActiveFilterCountBySection: (state, filterSection: string) => {
      return state.activeFilters.filter((f) => f.filterSection === filterSection).length;
    },
    selectIsFilterActive: (state, filterSection: string, filterName: string) => {
      return state.activeFilters.some(
        (f) => f.filterSection === filterSection && f.filterName === filterName && f.on
      );
    },
    selectSortBy: (state) => state.sortBy,
  },
});

export const filtersReducer = filtersSlice.reducer;
export const {setActiveFilters, setSortBy} = filtersSlice.actions;
export const {
  selectActiveFilters,
  selectHasActiveFilters,
  selectActiveFilterGroups,
  selectActiveFilterCount,
  selectActiveFilterCountBySection,
  selectIsFilterActive,
  selectSortBy,
} = filtersSlice.selectors;
